import { Link } from 'react-router-dom'
import { Accordion } from './Accordion'

export default function SolutionsIntroAccordion() {
  const accordions = [
    {
      title: 'Adaptation Planning',
      content: (
        <p>
          <b>Guide communities through changing climate risk.</b>
          <br />
          Resilience Explorer® gives adaptation professionals a single, consistent evidence base to
          bring others on the journey.
        </p>
      ),
      url: '/solutions/adaptation-planning',
    },
    {
      title: 'Land Use Planning and Development',
      content: (
        <p>
          <b>Design tomorrow's growth for tomorrow's risk.</b>
          <br />
          Resilience Explorer® gives land use planners the evidence to make development and zoning
          decisions that are defensible today and safe for generations to come.
        </p>
      ),
      url: '/solutions/land-use-planning',
    },
    {
      title: 'Asset and Infrastructure Planning',
      content: (
        <p>
          <b>Invest in the right assets, in the right places, at the right time.</b>
          <br />
          Resilience Explorer® gives asset and infrastructure managers a clear, current picture of
          climate and natural hazard risk across their portfolio, so every capital decision is one
          they can stand behind.
        </p>
      ),
      url: '/solutions/asset-infrastructure-planning',
    },
    {
      title: 'Emergency Planning and Business Continuity',
      content: (
        <p>
          <b>The benefit of hindsight, beforehand.</b>
          <br />
          Simulate hazard events, model how impacts cascade across interdependent networks, identify
          vulnerable populations, and test response plans against realistic scenarios.
        </p>
      ),
      url: '/solutions/emergency-planning',
    },
    {
      title: 'Compliance and Financial Reporting',
      content: (
        <p>
          <b>Meet your disclosure obligations and strengthen your financial position.</b>
          <br />
          Quantify climate and hazard exposure across your assets, generate spatially explicit
          evidence for XRB, TCFD, and ISSB reporting, and automate audit-ready documentation.
        </p>
      ),
    },
    {
      title: 'Research and Consultancy',
      content: (
        <p>
          <b>Make your work go further and be at the cutting edge.</b>
          <br />
          Deliver bespoke projects and work without building the capability from scratch, and offer
          clients a living evidence base that outlasts a single engagement.
        </p>
      ),
    },
  ]

  return (
    <div className="flex flex-col w-full gap-8 sm:gap-12">
      <h2 className="text-3xl font-light leading-tight tracking-tight mt-4b text-text-primary sm:text-5xl">
        I manage risk through...
      </h2>
      <Accordion
        items={accordions.map(({ title, content, url }) => ({
          value: title,
          title,
          content: (
            <div className="flex flex-col px-4 md:px-8">
              {content}
              {url && (
                <Link
                  className="inline-flex items-center gap-1 mt-4 text-sm font-semibold no-underline transition-colors text-brand-blue hover:text-brand-navy"
                  to={url}
                >
                  Learn More →
                </Link>
              )}
            </div>
          ),
        }))}
      />
    </div>
  )
}
